import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import axios from 'axios';


const EmployeeRecord = () => {

    const { employeerecordid } = useParams();
    const [brand, setBrand] = useState([])
    const [vendordata, setVendorData] = useState([])
    const [uid, setUid] = useState([])
    const [hide, setHide] = useState(false)
    const [cid, setCid] = useState("")
    const [error, setError] = useState({})
    const [confirmationVisibleMap, setConfirmationVisibleMap] = useState({});
    const [checked, setChecked] = React.useState([true, false]);


    const [value, setValue] = useState({
        training: '' || uid.training,
        attendee: '' || uid.attendee,
        instructor: '' || uid.instructor,
        description: '' || uid.description,
        feedback: '' || uid.feedback,

    })

    useEffect(() => {
        setValue({

            training: uid.training,
            attendee: uid.attendee,
            instructor: uid.instructor,
            description: uid.description,
            feedback: uid.feedback,



        })
    }, [uid])



    const validateForm = () => {
        let isValid = true
        const newErrors = {}


        if (!value.training) {
            isValid = false;
            newErrors.training = "Training is Required"
        }

        if (!value.attendee) {
            isValid = false
            newErrors.attendee = "Attendee is Required"
        }

        if (!value.instructor) {
            isValid = false;
            newErrors.instructor = "Instructor is Required"
        }

        if (!value.description) {
            isValid = false;
            newErrors.description = "Descriptionn is Required"
        }

        if (!value.feedback) {
            isValid = false;
            newErrors.feedback = "FeedBack is Required"
        }

        setError(newErrors)
        return isValid
    }




    const getEmployeeDetails = () => {
        const data = {
            u_id: employeerecordid,
            tablename: "awt_employerecord"
        }
        axios.post(`${BASE_URL}/update_data`, data)
            .then((res) => {
                setUid(res.data[0])


                setValue(prevState => ({
                    ...prevState,
                    instructor: data.instructor || '',
                    description: data.description || '',
                    feedback: data.feedback || '',
                }));

            })
            .catch((err) => {
                console.log(err)
            })
    }

    useEffect(() => {
        if (employeerecordid !== ":employeerecordid") {
            getEmployeeDetails()
            // setHide(true)
        }
    }, [employeerecordid])




    const Navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const data = {
                training: value.training,
                attendee: value.attendee,
                instructor: value.instructor,
                description: value.description,
                feedback: value.feedback,
                u_id: employeerecordid !== ":employeerecordid" ? employeerecordid : undefined
            };

            axios.post(`${BASE_URL}/add_employerecord`, data)
                .then((res) => {
                    const { message, id } = res.data;

                    if (message === "Data Inserted") {
                        alert("Data Added Successfully");
                        // Do NOT navigate after insert
                        setHide(true);
                    } else if (message === "Data Updated") {
                        alert("Data Updated Successfully");
                        Navigate(`/employeerecord`); // ✅ Navigate only on update
                    }

                    setValue({
                        training: '',
                        attendee: '',
                        instructor: '',
                        description: '',
                        feedback: ''
                    });
                })
                .catch((err) => {
                    if (err.response && err.response.status === 409) {
                        alert(err.response.data.message || "Duplicate Entry!");
                    } else {
                        alert("Something went wrong!");
                    }
                    console.log(err);
                });
        }
    };



    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    return (

        <div class="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Employee Training Record</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3" onSubmit={handleSubmit}>
                                        <div class='row'>
                                            <div class="form-group col-lg-4">
                                                <label for="exampleInputUsername1">Training Date<span className="text-danger">*</span></label>
                                                <input type="date" class="form-control" id="exampleInputUsername1" value={value.training} placeholder="Training Date" name='training' onChange={onhandleChange} />
                                                {<span className='text-danger'>{error.training}</span>}
                                            </div>

                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Attendee<span className='text-danger'>*</span> </label>
                                                <select class="form-control form-control-lg" id="exampleFormControlSelect1" value={value.attendee} onChange={onhandleChange} name='attendee'>
                                                    <option>Select</option>
                                                    <option>Admin</option>
                                                    <option>BalKrishana</option>
                                                    <option>Ankit</option>
                                                    <option>Athrava</option>
                                                    <option>Manshi Suresh</option>
                                                </select>
                                                {<span className='text-danger'> {error.attendee} </span>}
                                            </div>

                                            <div class="form-group col-lg-4">
                                                <label for="exampleInputUsername1">Instructor<span className='text-danger'>*</span></label>
                                                <input type="text" class="form-control" id="exampleInputUsername1" value={value.instructor} placeholder="Instructor" name='instructor' onChange={onhandleChange} />
                                                {<span className='text-danger'>{error.instructor}</span>}
                                            </div>

                                            <div class="form-group col-lg-8">
                                                <label for="exampleTextarea1">Description<span className='text-danger'>*</span></label>
                                                <textarea class="form-control" id="exampleTextarea1" value={value.description} placeholder="Description" name='description' onChange={onhandleChange}></textarea>
                                                {<span className='text-danger'> {error.description} </span>}
                                            </div>

                                            <div class="form-group col-lg-4">
                                                <label for="exampleTextarea1">Feedback<span className='text-danger'>*</span></label>
                                                <textarea class="form-control" id="exampleTextarea1" value={value.feedback} placeholder="Feedback" name='feedback' onChange={onhandleChange}></textarea>
                                                {<span className='text-danger'> {error.feedback} </span>}
                                            </div>




                                        </div>




                                        <button type="submit" class="btn btn-primary mr-2">Submit</button>
                                        <button type='button' onClick={() => {
                                            window.location.reload()
                                        }} class="btn btn-light">Cancel</button>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default EmployeeRecord